import { Component } from "./base/copmonent";
import { ensureElement } from "../utils/utils";
export class CardsRenderer extends Component {
    constructor(container, actions) {
        super(container);
        this._title = ensureElement(`.card__title`, container);
        this._image = container.querySelector(`.card__image`);
        this._button = container.querySelector(`.card__button`);
        this._description = container.querySelector(`.card__text`);
        this._category = container.querySelector(`.card__category`);
        this._price = container.querySelector(`.card__price`);
        this._index = container.querySelector(`.basket__item-index`);
        if (actions === null || actions === void 0 ? void 0 : actions.onClick) {
            if (this._button) {
                this._button.addEventListener('click', actions.onClick);
            }
            else {
                container.addEventListener('click', actions.onClick);
            }
        }
    }
    set titleBtn(value) {
        if (this._button) {
            this._button.textContent = value;
        }
    }
    disableBtn(value) {
        if (!value) {
            if (this._button) {
                this._button.disabled = true;
            }
        }
    }
    set id(value) {
        this.container.dataset.id = value;
    }
    get id() {
        return this.container.dataset.id || '';
    }
    set title(value) {
        this.setText(this._title, value);
    }
    get title() {
        return this._title.textContent || '';
    }
    set image(value) {
        this.setImage(this._image, value, this.title);
    }
    set description(value) {
        if (Array.isArray(value)) {
            this._description.replaceWith(...value.map(str => {
                const descTemplate = this._description.cloneNode();
                this.setText(descTemplate, str);
                return descTemplate;
            }));
        }
        else {
            this.setText(this._description, value);
        }
    }
    ;
    set category(value) {
        if (value === 'софт-скил') {
            this._category.classList.add('card__category_soft');
        }
        else if (value === 'другое') {
            this._category.classList.add('card__category_other');
        }
        else if (value === 'дополнительное') {
            this._category.classList.add('card__category_additional');
        }
        else if (value === 'кнопка') {
            this._category.classList.add('card__category_button');
        }
        else if (value === 'хард-скил') {
            this._category.classList.add('card__category_hard');
        }
        this.setText(this._category, value);
    }
    get category() {
        return this._category.textContent || '';
    }
    set price(value) {
        this.setText(this._price, value ? `${value.toString()} синапсов` : 'Бесценно');
        this.disableBtn(value);
    }
    ;
    get price() {
        return Number(this._price.textContent || '');
    }
    ;
    set index(value) {
        this._index.textContent = value;
    }
    ;
    get index() {
        return this._index.textContent || '';
    }
    ;
}
